import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ILogs } from '@obvious.tech/constellation'

export const Logs = defineEntity('Logs', {
  endpoint: 'flow/api/Logs',
  schema: SNoop<ILogs>(),
})
